module.exports = __webpack_public_path__ + "static/echoAR-4692c570437a9391826c31faebb6a504.png";